module.exports = __webpack_public_path__ + "img/eea7008.webp";